import React, { Component, CSSProperties, ReactElement } from 'react';

import { CheckBoxLayout } from './../index'

interface ICheckBoxComponentProps {
  checked: boolean
  style?: CSSProperties
  className?: string
  disabled?: boolean
  icon?: ReactElement
  radio?: boolean
  label?: string
  id?: string;
  onClick: ()=>void
}

interface ICheckBoxComponentState {}

class CheckBoxComponent extends Component<ICheckBoxComponentProps, ICheckBoxComponentState> {
    render() {
        return (
            <CheckBoxLayout
              {...this.props}
            />
        );
    }
}

export default CheckBoxComponent;
